import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONTS,
  TableRow,
} from "../../../../constants/Styles";

export const InputContainer = styled.div`
  padding: 0.25rem;
  background-color: ${COLORS.badgeGray};
  border-radius: 0.75rem;
`;

export const UneditableChildTableRow = styled(TableRow)`
  background-color: ${COLORS.black};
  font-size: ${FONT_SIZE.size13};
`;

export const PartDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TableContainer = styled.div`
  border: 1px solid ${COLORS.midGray};
  border-radius: 1rem;
  padding: 1rem;
`;

export const TableTitle = styled.div`
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size14};
  font-family: ${FONTS.spaceGrotesk};
  margin-bottom: 1rem;
`;

export const SelectInputContainer = styled(InputContainer)`
  width: 100%;
`;

export const ActionAndSummarySection = styled.div`
  margin: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: column;
`;
